import React, { FC } from 'react'

interface CurrentPositionMarkerProps {
  isLastKnownPosition: boolean
}

const CurrentPositionMarker: FC<CurrentPositionMarkerProps> = ({
  isLastKnownPosition,
}) => {
  return (
    <svg
      width="38"
      height="51"
      viewBox="0 0 38 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 48C22.4978 48 25.3333 46.9255 25.3333 45.6C25.3333 44.2745 22.4978 43.2 19 43.2C15.5022 43.2 12.6666 44.2745 12.6666 45.6C12.6666 46.9255 15.5022 48 19 48Z"
          fill="#CCCCCC"
        />
      </g>
      <path
        d="M14.4494 36.7229L14.4493 36.7229C6.40948 34.6496 0.791667 27.3813 0.791667 19.0445C0.791667 8.97886 8.96238 0.791667 19 0.791667C29.0376 0.791667 37.2083 8.97886 37.2083 19.0445C37.2083 27.3691 31.6006 34.6348 23.5755 36.7165C23.2217 36.8083 22.9264 37.0102 22.6891 37.2235C22.4485 37.4398 22.2275 37.7043 22.0247 37.9807C21.6279 38.5218 21.2356 39.2014 20.8615 39.8496L20.8465 39.8755C20.423 40.6093 20.0277 41.2912 19.6421 41.7935C19.4503 42.0432 19.2867 42.2137 19.1529 42.316C19.0688 42.3804 19.0195 42.4004 19.0007 42.4064C18.9823 42.4003 18.9342 42.3802 18.8527 42.3175C18.7201 42.2156 18.5576 42.0457 18.367 41.7963C17.9838 41.2948 17.591 40.614 17.1699 39.8814C17.1699 39.8814 17.1699 39.8813 17.1699 39.8813L17.1558 39.8568C16.7832 39.2082 16.3925 38.5281 15.9971 37.9868C15.7952 37.7105 15.575 37.446 15.3351 37.2297C15.0985 37.0165 14.8034 36.8143 14.4494 36.7229Z"
        fill="white"
        stroke="#979797"
        strokeWidth="1.58333"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 35C27.8366 35 35 27.8366 35 19C35 10.1634 27.8366 3 19 3C10.1634 3 3 10.1634 3 19C3 27.8366 10.1634 35 19 35Z"
        fill={isLastKnownPosition ? '#000000' : '#FFDD00'}
      />
      <mask
        id="mask0"
        type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="32"
        height="32"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 35C27.8366 35 35 27.8366 35 19C35 10.1634 27.8366 3 19 3C10.1634 3 3 10.1634 3 19C3 27.8366 10.1634 35 19 35Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)"></g>
      <rect
        x="12.4255"
        y="23.2546"
        width="1.69853"
        height="3.51838"
        rx="0.849265"
        fill="#D8D8D8"
        stroke="#4D4D4D"
        strokeWidth="1.03125"
      />
      <rect
        x="23.3447"
        y="23.2546"
        width="1.69853"
        height="3.51838"
        rx="0.849265"
        fill="#D8D8D8"
        stroke="#4D4D4D"
        strokeWidth="1.03125"
      />
      <path
        d="M15.125 10.5H22.3438C24.3458 10.5 25.9688 12.123 25.9688 14.125V22.375C25.9688 23.8075 24.8075 24.9688 23.375 24.9688H14.0937C12.6613 24.9688 11.5 23.8075 11.5 22.375V14.125C11.5 12.123 13.123 10.5 15.125 10.5Z"
        fill="#E6E6E6"
        stroke="#4D4D4D"
      />
      <path
        d="M14.8823 13.2298H22.5864C23.4493 13.2298 24.1489 13.9294 24.1489 14.7923V18.5993H13.3198V14.7923C13.3198 13.9294 14.0194 13.2298 14.8823 13.2298Z"
        fill="white"
        stroke="#4D4D4D"
      />
      <path
        d="M24.1332 21.3741C24.1332 21.8431 23.753 22.2234 23.284 22.2234C22.8149 22.2234 22.4347 21.8431 22.4347 21.3741C22.4347 20.9051 22.8149 20.5248 23.284 20.5248C23.753 20.5248 24.1332 20.9051 24.1332 21.3741Z"
        fill="#FFDD00"
        stroke="#4D4D4D"
        strokeWidth="1.03125"
      />
      <path
        d="M15.034 21.3741C15.034 21.8431 14.6537 22.2234 14.1847 22.2234C13.7157 22.2234 13.3354 21.8431 13.3354 21.3741C13.3354 20.9051 13.7157 20.5248 14.1847 20.5248C14.6537 20.5248 15.034 20.9051 15.034 21.3741Z"
        fill="#FFDD00"
        stroke="#4D4D4D"
        strokeWidth="1.03125"
      />
      <defs>
        <filter
          id="filter0_f"
          x="10.2995"
          y="40.8328"
          width="17.401"
          height="9.53434"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.18359"
            result="effect1_foregroundBlur"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default CurrentPositionMarker
